<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="-1"
    hide-default-footer
    class="elevation-2"
  >
    <template v-slot:item.qtd_servicos="{ item }">
      {{
        item.qtd_servicos
          ? item.qtd_servicos
          : "-" | parseNumberToFloatBrIgnoringNaN
      }}
    </template>
    <template v-slot:item.qtd_violada="{ item }">
      {{
        item.qtd_violada
          ? item.qtd_violada
          : "-" | parseNumberToFloatBrIgnoringNaN
      }}
    </template>
    <template v-slot:item.valor_creditado="{ item }">
      {{
        item.valor_creditado
          ? item.valor_creditado
          : "-" | parseNumberToFloatBrIgnoringNaN
      }}
    </template>
    <template v-slot:item.psp="{ item }">
      {{ item.psp ? item.psp : "-" | parseNumberToFloatBrIgnoringNaN }} %
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "DataTableSupGer",
    props: {
      headers: {
        type: Array,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
    },
  };
</script>
